import { useState, useRef, useEffect } from 'react';

// Loads the Emscripten WASM module by injecting a <script> tag.
// Returns { moduleRef, ready, status }.
// `status` is a non-empty string while loading or on error; empty string when ready.
export function useWasm(src) {
    const moduleRef = useRef(null);
    const [ready, setReady]   = useState(false);
    const [status, setStatus] = useState('Loading wasm module…');

    useEffect(() => {
        const script = document.createElement('script');
        script.src = src;

        script.onload = () => {
            if (typeof window.createModule !== 'function') {
                setStatus(
                    `${src} loaded but did not export createModule.\n` +
                    'Copy the build output to frontend/public/:\n\n' +
                    '  cp cmake-build-emscripten-debug/prolog_visualiser.{js,wasm} frontend/public/'
                );
                return;
            }
            window.createModule()
                .then(m => { moduleRef.current = m; setReady(true); setStatus(''); })
                .catch(err => setStatus(`Module init failed: ${err}`));
        };

        script.onerror = () => setStatus(
            `Could not load ${src}.\n` +
            'Copy the build output to frontend/public/:\n\n' +
            '  cp cmake-build-emscripten-debug/prolog_visualiser.{js,wasm} frontend/public/'
        );

        document.body.appendChild(script);
        // Script tags are intentionally not removed — removing a loaded script
        // does not unload its side-effects (window.createModule), and we only
        // ever call this once per page load.
    }, [src]); // eslint-disable-line react-hooks/exhaustive-deps

    return { moduleRef, ready, status };
}
